"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6618],{

/***/ 96618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ homePage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(95627);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/homePage/adContainer/googleAdContainer.js
var googleAdContainer = __webpack_require__(52821);
// EXTERNAL MODULE: ./src/api/commonConstants.js
var commonConstants = __webpack_require__(96781);
// EXTERNAL MODULE: ./src/components/homePage/mainContainer/index.js + 3 modules
var mainContainer = __webpack_require__(74771);
// EXTERNAL MODULE: ./src/constants/websiteSchema/breadcrumb.json
var breadcrumb = __webpack_require__(21253);
// EXTERNAL MODULE: ./src/localization/i8intl.js + 2 modules
var i8intl = __webpack_require__(54269);
// EXTERNAL MODULE: ./src/constants/MasterConfigContext.js
var MasterConfigContext = __webpack_require__(39712);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./src/components/Ads/index.js
var Ads = __webpack_require__(99126);
// EXTERNAL MODULE: ./src/constants/state.js
var state = __webpack_require__(25613);
// EXTERNAL MODULE: ./src/constants/cricket.js
var cricket = __webpack_require__(34044);
// EXTERNAL MODULE: ./src/redux/actions/seriesAction.js
var seriesAction = __webpack_require__(98033);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(2185);
// EXTERNAL MODULE: ./src/constants/newsLetter.js
var newsLetter = __webpack_require__(31445);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/NewsLetter/FooterNewsLetter.js





var FooterNewsLetter = function FooterNewsLetter(_ref) {
  var size = _ref.size;
  var SUCCESS_TEXT = 'Email has been sent. Please check';
  var FAIL_TEXT = "Something went wrong Try again";

  var _useState = (0,react.useState)(''),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = (0,react.useState)('<strong>NOTE:</strong> By entering your email ID, you authorise <a href = "/">thelallantop.com</a> to send newsletters to your email.'),
      bottomText = _useState2[0],
      setBottomText = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isError = _useState3[0],
      setIsError = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      subscribeLoading = _useState4[0],
      setSubscribeLoading = _useState4[1];

  var handleSubscribeClick = function handleSubscribeClick() {
    setSubscribeLoading(true);
    (0,newsLetter/* requestSubscription */.HH)(email).then(function (res) {
      setBottomText(SUCCESS_TEXT);
      setSubscribeLoading(false);
      setIsError(false);
    })["catch"](function (err) {
      setBottomText(err !== null && err !== void 0 && err.data ? err === null || err === void 0 ? void 0 : err.data : FAIL_TEXT);
      setSubscribeLoading(false);
      setIsError(true);
    });
  };

  var containerStyle = {
    display: 'flex',
    backgroundColor: '#F8F0E3',
    borderRadius: '8px',
    width: '328px',
    alignItems: 'center'
  };
  var inputStyle = {
    border: 'none',
    outline: 'none',
    padding: '0px 15px',
    backgroundColor: '#F8F0E3',
    fontSize: '14px',
    fontWeight: "40",
    color: '#333'
  };
  var buttonStyle = {
    backgroundColor: '#FFC609',
    border: 'none',
    padding: '10px 20px',
    fontWeight: '400',
    borderRadius: '8px',
    color: '#000',
    cursor: 'pointer',
    fontSize: "12px",
    minWidth: "94px"
  };
  return (size === null || size === void 0 ? void 0 : size.width) > 700 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "container my-2 ",
    style: {
      height: "164px",
      backgroundColor: "#FBF8F1",
      borderRadius: "10px"
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "d-flex align-items-center justify-content-center",
      style: {
        gap: "10%"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "m-0 p-0",
          style: {
            fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
            fontWeight: 900,
            fontSize: "25px"
          },
          children: "Subscribe "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "m-0 p-0",
          style: {
            fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
            fontWeight: 900,
            fontSize: "25px"
          },
          children: " to Our Newsletter"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: containerStyle,
        className: "shadow-sm",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          value: email,
          onChange: function onChange(event) {
            return setEmail(event.target.value);
          },
          type: "email",
          placeholder: "Enter Your Email",
          style: inputStyle,
          className: "form-control-plaintext",
          onKeyDown: function onKeyDown(e) {
            if (e.key === "Enter") {
              handleSubscribeClick();
            }
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: handleSubscribeClick,
          style: buttonStyle,
          className: "ms-2",
          children: subscribeLoading ? '...' : 'SUBSCRIBE'
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          width: "147px",
          height: "130px"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: "w-100 h-100",
          src: "./assets/images/news_letter.png"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "m-0 p-0 text-end me-5 mt-3",
      dangerouslySetInnerHTML: {
        __html: bottomText
      },
      style: {
        fontWeight: isError ? 600 : 200,
        fontSize: isError ? "13px" : "9px",
        color: isError ? "red" : "#333"
      }
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "container my-2 ",
    style: {
      backgroundColor: "#FBF8F1",
      borderRadius: "10px"
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "d-flex align-items-center justify-content-center",
      style: {
        gap: "10%"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "m-0 p-0",
          style: {
            fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
            fontWeight: 900,
            fontSize: "25px"
          },
          children: "Subscribe "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "m-0 p-0",
          style: {
            fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
            fontWeight: 900,
            fontSize: "25px"
          },
          children: " to our Newsletter"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          width: "70px",
          height: "79px"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: "w-100 h-100",
          src: "./assets/images/news_letter.png"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: containerStyle,
      className: "shadow-sm mx-auto my-4",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        value: email,
        onChange: function onChange(event) {
          return setEmail(event.target.value);
        },
        type: "email",
        placeholder: "Enter Your Email",
        style: inputStyle,
        onKeyDown: function onKeyDown(e) {
          if (e.key === "Enter") {
            handleSubscribeClick();
          }
        },
        className: "form-control-plaintext"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: handleSubscribeClick,
        style: buttonStyle,
        className: "ms-2",
        children: subscribeLoading ? '...' : 'SUBSCRIBE'
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "m-0 p-0 text-center",
      dangerouslySetInnerHTML: {
        __html: bottomText
      },
      style: {
        fontWeight: isError ? 600 : 200,
        fontSize: isError ? "13px" : "9px",
        color: isError ? "red" : "#333"
      }
    })]
  });
};

/* harmony default export */ var NewsLetter_FooterNewsLetter = (FooterNewsLetter);
;// CONCATENATED MODULE: ./src/components/homePage/index.js









 // import TaboolaAdContainer from "./adContainer/taboolaContainer";




 // import ListingPage from "components/liveblog/listingPage";
// import { baseUrl } from "api/constants";
// import ElectionsWidget from "components/elections-2023/ElectionsWidget";
// import AuthorColumn from "./authorColumn";

var TaboolaAdContainer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 5198).then(__webpack_require__.bind(__webpack_require__, 95198));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(95198)];
    }
  }
});
var BlogWidget = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7642), __webpack_require__.e(9639)]).then(__webpack_require__.bind(__webpack_require__, 59639));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(59639)];
    }
  }
});
 // import FAQComponent from "components/faq";


 // import Sponsor from "components/Sponsor";
// import getConfig from "next/config";
// import CricketSlider from "./cricketSlider";
// import LiveShow from "./liveShow/liveShow";
// import {
//   fetchAndActivate,
//   getRemoteConfig,
//   getString,
// } from "firebase/remote-config";
// import app from "utils/firebase";


 // import WidgetHome from "components/cricket/WidgetHome";









var LatestVideos = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2007).then(__webpack_require__.bind(__webpack_require__, 92007));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(92007)];
    }
  }
});
var VisualStories = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7758), __webpack_require__.e(719), __webpack_require__.e(9336)]).then(__webpack_require__.bind(__webpack_require__, 63586));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(63586)];
    }
  }
}); // import { Container } from "react-bootstrap";

var WidgetHomeIpl = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(8087), __webpack_require__.e(8012)]).then(__webpack_require__.bind(__webpack_require__, 80618));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(80618)];
    }
  }
}); // const ShortsSlider = dynamic(() =>
//   import("../short-video/shortSlider.js", { ssr: true })
// );
// const TopShows = dynamic(() => import("./topShows/topShows.js", { ssr: true }));
// const TopShowsWidget = dynamic(() =>
//   import("./topShows/topShowsWidget.js", { ssr: true })
// );

var CategoryPosts = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7758), __webpack_require__.e(719), __webpack_require__.e(7980)]).then(__webpack_require__.bind(__webpack_require__, 272));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(272)];
    }
  }
});

var HomePage = function HomePage(_ref) {
  var _buttonStyle, _responseVs$data;

  var _ref$featuredPosts = _ref.featuredPosts,
      featuredPosts = _ref$featuredPosts === void 0 ? [] : _ref$featuredPosts,
      _ref$bannerData = _ref.bannerData,
      bannerData = _ref$bannerData === void 0 ? [] : _ref$bannerData,
      _ref$liveShowData = _ref.liveShowData,
      liveShowData = _ref$liveShowData === void 0 ? [] : _ref$liveShowData,
      _ref$shortsData = _ref.shortsData,
      shortsData = _ref$shortsData === void 0 ? [] : _ref$shortsData,
      _ref$topShowsData = _ref.topShowsData,
      topShowsData = _ref$topShowsData === void 0 ? [] : _ref$topShowsData,
      _ref$NewsPageData = _ref.NewsPageData,
      NewsPageData = _ref$NewsPageData === void 0 ? [] : _ref$NewsPageData,
      _ref$quizHomeData = _ref.quizHomeData,
      quizHomeData = _ref$quizHomeData === void 0 ? [] : _ref$quizHomeData,
      _ref$electionTopicDat = _ref.electionTopicData,
      electionTopicData = _ref$electionTopicDat === void 0 ? [] : _ref$electionTopicDat,
      _ref$topShowsWidgetDa = _ref.topShowsWidgetData,
      topShowsWidgetData = _ref$topShowsWidgetDa === void 0 ? [] : _ref$topShowsWidgetDa,
      _ref$responseVs = _ref.responseVs,
      responseVs = _ref$responseVs === void 0 ? {} : _ref$responseVs,
      _ref$liveBlogWidgetDa = _ref.liveBlogWidgetData,
      liveBlogWidgetData = _ref$liveBlogWidgetDa === void 0 ? [] : _ref$liveBlogWidgetDa,
      _ref$homePageVideosDa = _ref.homePageVideosData,
      homePageVideosData = _ref$homePageVideosDa === void 0 ? [] : _ref$homePageVideosDa,
      _ref$authorWidgetData = _ref.authorWidgetData,
      authorWidgetData = _ref$authorWidgetData === void 0 ? [] : _ref$authorWidgetData,
      _ref$topPodcastData = _ref.topPodcastData,
      topPodcastData = _ref$topPodcastData === void 0 ? [] : _ref$topPodcastData,
      pointsData = _ref.pointsData,
      scoreData = _ref.scoreData,
      cricketData = _ref.cricketData,
      loadAll = _ref.loadAll;
  // liveBlogWidgetData = [];
  var masterConfig = (0,react.useContext)(MasterConfigContext/* MasterConfigContext */.d);

  var _useState = (0,react.useState)(false),
      isSubscribed = _useState[0],
      setIsSubscribed = _useState[1];

  (0,react.useEffect)(function () {
    setIsSubscribed(localStorage.getItem('subscribed'));
  }, []);
  var STATIC_BREADCRUMP = [{
    displayText: "कौन जीता-कौन हारा",
    url: "/election/delhi-assembly-chunav/results",
    keyToShow: "Delhi_KaunJeeta"
  }, {
    displayText: "प्रमुख उम्मीदवार",
    url: "/election/delhi-assembly-chunav/key-candidates",
    keyToShow: "DelhiKeyCandidate"
  }, {
    displayText: "एग्जिट पोल",
    url: "/election/delhi-assembly-chunav/exit-poll",
    keyToShow: "DelhiExitPollPage"
  }, {
    displayText: "विधान सभा रिजल्ट",
    url: "/election/delhi-assembly-chunav/party-wise-result",
    keyToShow: "DelhiResultPage"
  }, {
    displayText: "शेड्यूल",
    url: "/election/delhi-assembly-chunav/schedule",
    keyToShow: "DelhiSchedulePage"
  }, {
    displayText: "सामान्य प्रश्न",
    url: "/election/assembly-chunav/faq",
    keyToShow: ""
  }];

  var _useState2 = (0,react.useState)(false),
      show = _useState2[0],
      setShow = _useState2[1];

  var handleOpen = function handleOpen() {
    return setShow(true);
  };

  var handleClose = function handleClose() {
    return setShow(false);
  };

  (0,react.useEffect)(function () {
    var timer = setTimeout(function () {
      var showPopup = (0,newsLetter/* showPopupOrNot */.LF)();
      console.log(showPopup, ' show popup');

      if (showPopup) {
        localStorage.setItem('lastShowedSubscribe', Date.now());
      }

      setShow(showPopup);
    }, 5000);
    return function () {
      return clearTimeout(timer);
    };
  }, []); //needs to be changed before deploying to prod

  var masterObj = masterConfig[state/* stateData.home-page.masterConfigKey */.i["home-page"].masterConfigKey];
  console.log("topShowsWidgetData 123 ", masterConfig);
  var router = (0,next_router.useRouter)();

  var _useState3 = (0,react.useState)(""),
      language = _useState3[0],
      setLanguage = _useState3[1];

  var _useState4 = (0,react.useState)(loadAll),
      loadScrollableComponents = _useState4[0],
      setLoadScrollableComponents = _useState4[1];

  var SUCCESS_TEXT = '<strong>NOTE:</strong> Email has been sent. Please check';
  var FAIL_TEXT = "Something went wrong Try again";

  var _useState5 = (0,react.useState)(''),
      email = _useState5[0],
      setEmail = _useState5[1];

  var _useState6 = (0,react.useState)('<strong>NOTE:</strong> By entering your email ID, you authorise <a href = "/">thelallantop.com</a> to send newsletters to your email.'),
      bottomText = _useState6[0],
      setBottomText = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isError = _useState7[0],
      setIsError = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      subscribeLoading = _useState8[0],
      setSubscribeLoading = _useState8[1];

  var handleSubscribeClick = function handleSubscribeClick() {
    setSubscribeLoading(true);
    (0,newsLetter/* requestSubscription */.HH)(email).then(function (res) {
      setBottomText(SUCCESS_TEXT);
      setSubscribeLoading(false);
      setIsError(false);
    })["catch"](function (err) {
      setBottomText(err !== null && err !== void 0 && err.data ? err === null || err === void 0 ? void 0 : err.data : FAIL_TEXT);
      setSubscribeLoading(false);
      setIsError(true);
    });
  };

  var containerStyle = {
    display: 'flex',
    backgroundColor: '#F8F0E3',
    borderRadius: '8px',
    width: '300px',
    alignItems: 'center'
  };
  var inputStyle = {
    border: 'none',
    outline: 'none',
    padding: '0px 15px',
    backgroundColor: '#F8F0E3',
    fontSize: '14px',
    fontWeight: "40",
    color: '#333'
  };
  var buttonStyle = (_buttonStyle = {
    backgroundColor: '#FFC609',
    border: 'none',
    padding: '10px 20px',
    fontWeight: '400',
    borderRadius: '8px',
    color: '#000',
    cursor: 'pointer',
    fontSize: "12px"
  }, (0,defineProperty/* default */.Z)(_buttonStyle, "cursor", "pointer"), (0,defineProperty/* default */.Z)(_buttonStyle, "minWidth", "106px"), _buttonStyle); // useEffect(() => {
  //   let timer;
  //   const handleVisibilityChange = () => {
  //     setIsActive(!document.hidden);
  //   };
  //   if (isActive) {
  //     timer = setInterval(() => {
  //       setTimeSpent((prevTime) => prevTime + 1);
  //     }, 1000);
  //   } else {
  //     clearInterval(timer);
  //   }
  //   document.addEventListener("visibilitychange", handleVisibilityChange);
  //   return () => {
  //     clearInterval(timer);
  //     const obj = {
  //       eventName: "Time_On_Page",
  //       pageTitle: "Home Page",
  //       timeSpent: timeSpent,
  //       propertyObject: {
  //         timeSpent: timeSpent
  //       }
  //     }
  //     callGaEvent(obj)
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, [isActive]);
  // const [scrollDepth, setScrollDepth] = useState(0);

  var thresholds = [25, 50, 75, 100];
  var triggered = new Set();
  (0,react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var scrollTop = window.scrollY;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var scrolled = scrollTop / docHeight * 100;
      thresholds.forEach(function (threshold) {
        if (scrolled >= threshold && !triggered.has(threshold)) {
          // console.log(`Scrolled ${threshold}%`);
          triggered.add(threshold);
          var obj = {
            eventName: "Page_Scroll_Depth",
            pageTitle: "Home Page",
            propertyObject: {
              depth: threshold
            }
          };
          (0,cricket/* callGaEvent */.ut)(obj);
        }
      }); // setScrollDepth(scrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return function () {
      return window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  (0,react.useEffect)(function () {
    setLanguage((0,i8intl/* getLanguage */.G3)());
  }, []);
  console.log("responseVs", liveBlogWidgetData);
  var size = (0,commonConstants/* useWindowSize */.iP)();
  console.log("sizeeeee", size);

  var _useState9 = (0,react.useState)(true),
      firstScroll = _useState9[0],
      setFirstScroll = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      adCalled = _useState10[0],
      setAdCalled = _useState10[1];

  (0,react.useEffect)(function () {
    if (size.width) {
      apstag.fetchBids({
        slots: size.width < 768 ? (0,Ads/* createApsSlotsHomeMobile */.Zy)({}) : (0,Ads/* createApsSlotsHomeDesktop */.we)({}),
        timeout: 2e3
      }, Ads/* apstagBidCallback */.O8);
    }
  }, [size.width]);
  (0,react.useEffect)(function () {
    function onFirstScroll() {
      return _onFirstScroll.apply(this, arguments);
    }

    function _onFirstScroll() {
      _onFirstScroll = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setFirstScroll(true);
                setLoadScrollableComponents(true);
                window._taboola = window._taboola || [];

                _taboola.push({
                  homepage: "auto"
                });

                !function (e, f, u, i) {
                  if (!document.getElementById(i)) {
                    e.async = 1;
                    e.src = u;
                    e.id = i;
                    f.parentNode.insertBefore(e, f);
                  }
                }(document.createElement("script"), document.getElementsByTagName("script")[0], "//cdn.taboola.com/libtrc/indiatoday-thelallantop/loader.js", "tb_loader_script");

                if (window.performance && typeof window.performance.mark === "function") {
                  window.performance.mark("tbl_ic");
                }

                window._taboola = window._taboola || [];

                _taboola.push({
                  mode: "alternating-thumbnails-a",
                  container: "taboola-below-homepage-thumbnails",
                  placement: "Below Homepage Thumbnails",
                  target_type: "mix"
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _onFirstScroll.apply(this, arguments);
    }

    function handleScroll() {
      onFirstScroll();
      window.removeEventListener("scroll", handleScroll);
    }

    window.addEventListener("scroll", handleScroll);
  }, []);
  (0,react.useEffect)(function () {
    // var showAds = true;
    // if (process.env.NEXT_PUBLIC_ADS_ONSCROLL === "true" && !firstScroll) {
    //   showAds = false;
    // }
    setTimeout(function () {
      window.googletag = window.googletag || {
        cmd: []
      };

      if (window.screen.width > 600) {
        if (router.pathname.includes("/text") || router.pathname.includes("/video")) {
          googletag.cmd.push(function () {
            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_ATF_728x90", [[728, 90], [970, 250], [970, 90]], "div-gpt-ad-1701945163318-0").addService(googletag.pubads());
            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_ATF_300x250", [300, 250], "div-gpt-ad-1701945220410-0").addService(googletag.pubads());
            {
              document.getElementById("div-gpt-ad-1701945220410-1") && googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_1_728x90", [728, 90], "div-gpt-ad-1701945220410-1").addService(googletag.pubads());
            }
            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_2_728x90", [728, 90], "div-gpt-ad-1701945220410-2").addService(googletag.pubads());
            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_3_300x250", [300, 250], "div-gpt-ad-1701945220410-3").addService(googletag.pubads()); // googletag.defineSlot('/1007232/Lallantop_Desktop_ROS_BTF_300x250', [[300, 250], [300, 600]], 'div-gpt-ad-1701945864013-0').addService(googletag.pubads());
            // googletag.defineOutOfPageSlot('/1007232/Lallantop_Mobile_HP_Mweb_Interstitial',googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());
            // var SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;
            // googletag
            //   .pubads()
            //   .addEventListener("impressionViewable", function (event) {
            //     var slot = event.slot;
            //     if (
            //       slot.getTargeting(REFRESH_KEY).indexOf(REFRESH_VALUE) > -1
            //     ) {
            //       setTimeout(function () {
            //         googletag.pubads().refresh([slot]);
            //       }, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
            //     }
            //   });

            googletag.pubads().enableSingleRequest();
            googletag.pubads().setTargeting("Category", "LThomepage");
            googletag.pubads().setTargeting("Keywords", ["होम", "होम लल्लनटॉप", "Latest Hindi News", "Breaking Hindi News Live", "Today Hindi News and Headlines"]);
            googletag.enableServices();
            googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,Ads/* requestBiddingFromPWT */.WX)();
          });
        } else {
          googletag.cmd.push(function () {
            // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Desktop_HP_MTF_300x250",
            //     [300, 250],
            //     "div-gpt-ad-1726480392574-0"
            //   )
            //   .addService(googletag.pubads());
            googletag.defineSlot("/1007232/Lallantop_Desktop_HP_ATF_728x90", [[728, 90], [970, 250], [970, 90]], "div-gpt-ad-1701945163318-0").addService(googletag.pubads());
            googletag.defineSlot("/1007232/Lallantop_Desktop_HP_ATF_300x250", [300, 250], "div-gpt-ad-1701945220410-0").addService(googletag.pubads()); // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Desktop_HP_MTF_1_728x90",
            //     [
            //       [728, 90],
            //       [970, 250],
            //       [970, 90],
            //     ],
            //     "div-gpt-ad-1701945220410-1"
            //   )
            //   .addService(googletag.pubads());
            // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Desktop_HP_MTF_2_728x90",
            //     [
            //       [728, 90],
            //       [970, 250],
            //       [970, 90],
            //     ],
            //     "div-gpt-ad-1701945220410-2"
            //   )
            //   .addService(googletag.pubads());
            // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Desktop_HP_MTF_3_728x90",
            //     [
            //       [728, 90],
            //       [970, 90],
            //     ],
            //     "div-gpt-ad-1701945220410-4"
            //   )
            //   .addService(googletag.pubads());
            // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Desktop_HP_BTF_300x250",
            //     [300, 250],
            //     "div-gpt-ad-1701945220410-3"
            //   )
            //   .addService(googletag.pubads());

            googletag.pubads().enableSingleRequest();
            googletag.pubads().setTargeting("Category", "LThomepage");
            googletag.pubads().setTargeting("Keywords", ["होम", "होम लल्लनटॉप", "Latest Hindi News", "Breaking Hindi News Live", "Today Hindi News and Headlines"]);
            googletag.enableServices();
            googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,Ads/* requestBiddingFromPWT */.WX)();
          });
        }
      } else {
        if (router.pathname.includes("/text") || router.pathname.includes("/video")) {
          googletag.cmd.push(function () {
            {
              document.getElementById("div-gpt-ad-1701946028239-0") && googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_ATF_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-0").addService(googletag.pubads());
            }
            {
              document.getElementById("div-gpt-ad-1701946028239-1") && googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_MTF_1_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-1").addService(googletag.pubads());
            }
            {
              document.getElementById("div-gpt-ad-1701946028239-2") && googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_MTF_2_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-2").addService(googletag.pubads());
            }
            googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_Bottom_320x50", [320, 50], "div-gpt-ad-1701946324333-0").addService(googletag.pubads());
            googletag.defineOutOfPageSlot("/1007232/Lallantop_Mobile_ROS_Mweb_Interstitial", googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads()); // var SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;
            // googletag
            //   .pubads()
            //   .addEventListener("impressionViewable", function (event) {
            //     var slot = event.slot;
            //     if (
            //       slot.getTargeting(REFRESH_KEY).indexOf(REFRESH_VALUE) > -1
            //     ) {
            //       setTimeout(function () {
            //         googletag.pubads().refresh([slot]);
            //       }, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
            //     }
            //   });

            googletag.pubads().enableSingleRequest();
            googletag.pubads().setTargeting("Category", "LThomepage");
            googletag.pubads().setTargeting("Keywords", ["होम", "होम लल्लनटॉप", "Latest Hindi News", "Breaking Hindi News Live", "Today Hindi News and Headlines"]);
            googletag.enableServices();
            googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,Ads/* requestBiddingFromPWT */.WX)();
          });
        } else {
          googletag.cmd.push(function () {
            var REFRESH_KEY = "refresh";
            var REFRESH_VALUE = "true"; // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Desktop_HP_MTF_300x250",
            //     [300, 250],
            //     "div-gpt-ad-1726480392574-0"
            //   )
            //   .addService(googletag.pubads());

            googletag.defineSlot("/1007232/Lallantop_Mobile_HP_ATF_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-0").addService(googletag.pubads()); // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Mobile_HP_MTF_1_300x250",
            //     [
            //       [336, 280],
            //       [300, 250],
            //     ],
            //     "div-gpt-ad-1701946028239-1"
            //   )
            //   .addService(googletag.pubads());
            // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Mobile_HP_MTF_2_300x250",
            //     [
            //       [336, 280],
            //       [300, 250],
            //     ],
            //     "div-gpt-ad-1701946028239-2"
            //   )
            //   .addService(googletag.pubads());
            // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Mobile_HP_BTF_300x250",
            //     [
            //       [336, 280],
            //       [300, 250],
            //     ],
            //     "div-gpt-ad-1701946028239-3"
            //   )
            //   .addService(googletag.pubads());
            // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Mobile_HP_Bottom_320x50",
            //     [320, 50],
            //     "div-gpt-ad-1701946324333-0"
            //   )
            //   .addService(googletag.pubads());

            googletag.defineOutOfPageSlot("/1007232/Lallantop_Mobile_HP_Mweb_Interstitial", googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().setTargeting("Category", "LThomepage");
            googletag.pubads().setTargeting("Keywords", ["होम", "होम लल्लनटॉप", "Latest Hindi News", "Breaking Hindi News Live", "Today Hindi News and Headlines"]);
            googletag.enableServices();
            googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices(); // googletag.pubads().refresh();

            (0,Ads/* requestBiddingFromPWT */.WX)();
          });
        }
      } // apstag.fetchBids(
      //   {
      //     slots:
      //       size?.width < 499
      //         ? createApsSlotsRosMobile({})
      //         : createApsSlotsRosDesktop({}),
      //     timeout: 2e3,
      //   },
      //   apstagBidCallback
      // );
      // apstag.fetchBids(
      //   {
      //     slots:
      //       size.width < 499
      //         ? createApsSlotsHomeMobile({})
      //         : createApsSlotsHomeDesktop({}),
      //     timeout: 2e3,
      //   },
      //   apstagBidCallback
      // );

    }, 500); // if (showAds && !adCalled) {
    //   setAdCalled(true);
    //   console.log("adscalled");
    // }
  }, []);
  (0,react.useEffect)(function () {
    if (loadScrollableComponents) {
      if (!window.googletag) {
        window.googletag = {
          cmd: []
        };
      } // window.googletag.cmd.push(() => {
      //   googletag.destroySlots();
      // });


      setTimeout(function () {
        window.googletag.cmd.push(function () {
          var slots = [];

          if (window.screen.width > 600) {
            slots = [{
              id: "/1007232/Lallantop_Desktop_HP_MTF_300x250",
              size: [300, 250],
              div: "div-gpt-ad-1726480392574-0"
            }, {
              id: "/1007232/Lallantop_Desktop_HP_MTF_1_728x90",
              size: [[728, 90], [970, 250], [970, 90]],
              div: "div-gpt-ad-1701945220410-1"
            }, {
              id: "/1007232/Lallantop_Desktop_HP_MTF_2_728x90",
              size: [[728, 90], [970, 250], [970, 90]],
              div: "div-gpt-ad-1701945220410-2"
            }, {
              id: "/1007232/Lallantop_Desktop_HP_MTF_3_728x90",
              size: [[728, 90], [970, 250], [970, 90]],
              div: "div-gpt-ad-1701945220410-4"
            }, {
              id: "/1007232/Lallantop_Desktop_HP_BTF_300x250",
              size: [300, 250],
              div: "div-gpt-ad-1701945220410-3"
            }];
          } else {
            slots = [{
              id: "/1007232/Lallantop_Mobile_HP_MTF_300x250",
              size: [300, 250],
              div: "div-gpt-ad-1726480392574-0"
            }, {
              id: "/1007232/Lallantop_Mobile_HP_MTF_1_300x250",
              size: [[336, 280], [300, 250]],
              div: "div-gpt-ad-1701946028239-1"
            }, {
              id: "/1007232/Lallantop_Mobile_HP_MTF_2_300x250",
              size: [[336, 280], [300, 250]],
              div: "div-gpt-ad-1701946028239-2"
            }, // {
            //   id: "/1007232/Lallantop_Mobile_HP_MTF_3_300x250",
            //   size: [[336, 280], [300, 250]],
            //   div: "div-gpt-ad-1701946028239-4",
            // },
            {
              id: "/1007232/Lallantop_Mobile_HP_BTF_300x250",
              size: [[336, 280], [300, 250]],
              div: "div-gpt-ad-1701946028239-3"
            }, {
              id: "/1007232/Lallantop_Mobile_HP_Bottom_320x50",
              size: [320, 50],
              div: "div-gpt-ad-1701946324333-0"
            }];
          }

          slots.forEach(function (slot) {
            var adSlot = googletag.defineSlot(slot.id, slot.size, slot.div);

            if (adSlot) {
              adSlot.addService(googletag.pubads());
            } else {
              console.error("Failed to define slot: ".concat(slot.div));
            }
          });
          googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.pubads().enableLazyLoad();
          googletag.pubads().setTargeting("Category", "LThomepage");
          googletag.pubads().setTargeting("Keywords", ["होम", "होम लल्लनटॉप", "Latest Hindi News", "Breaking Hindi News Live", "Today Hindi News and Headlines"]);
          googletag.enableServices(); // Ensure all ad divs exist

          document.querySelectorAll("[id^='div-gpt-ad']").forEach(function (el) {
            if (!el) console.error("Ad div missing: ".concat(el.id));
          });
          googletag.pubads().refresh();
        });
      }, 300);
    }
  }, [loadScrollableComponents]);
  var dispatch = (0,es/* useDispatch */.I0)();
  (0,react.useEffect)(function () {
    dispatch((0,seriesAction/* setScoreData */.s)(scoreData));
  }, []);

  var ItemListSchema = function ItemListSchema() {
    var itemArray = [];
    var keyValueArray = [];
    var arrayforSchema;

    if ((router === null || router === void 0 ? void 0 : router.asPath) === "/") {
      arrayforSchema = featuredPosts;
    } else {
      arrayforSchema = NewsPageData === null || NewsPageData === void 0 ? void 0 : NewsPageData.entities;
    }

    console.log("arrayforSchema", arrayforSchema);

    for (var i = 1; i <= 10; i++) {
      var _arrayforSchema, _arrayforSchema2, _arrayforSchema3, _arrayforSchema4;

      var position = {};
      var typeKey = "@type";
      var typeValue = "ListItem";
      position[typeKey] = typeValue; // position.push({ [typeKey]: typeValue });

      typeKey = "position";
      typeValue = i;
      position[typeKey] = typeValue;
      typeKey = "name";
      typeValue = (_arrayforSchema = arrayforSchema) === null || _arrayforSchema === void 0 ? void 0 : (_arrayforSchema2 = _arrayforSchema[i - 1]) === null || _arrayforSchema2 === void 0 ? void 0 : _arrayforSchema2.title; // position.push({ [typeKey]: typeValue });

      position[typeKey] = typeValue; // typeKey = "description";
      // typeValue = featuredPosts[i - 1]?.shortText;
      // position[typeKey] = typeValue;

      typeKey = "url";
      typeValue = (_arrayforSchema3 = arrayforSchema) === null || _arrayforSchema3 === void 0 ? void 0 : (_arrayforSchema4 = _arrayforSchema3[i - 1]) === null || _arrayforSchema4 === void 0 ? void 0 : _arrayforSchema4.permalink;
      position[typeKey] = typeValue;
      keyValueArray.push(position);
    }

    itemArray = keyValueArray;
    console.log("ItemListSchema", featuredPosts); // for (let x = 1; x <= 10; x++) {
    //   var item = `"@type": "ListItem","name": ${
    //     featuredPosts[x]?.title
    //   },"position": ${x + 1},"url":${featuredPosts[x]?.permalink},`;
    //   itemArray.push(item);
    // }
    // var itemSchema = `{"@context": "https://schema.org","@type": "ItemList","itemListElement": ${itemArray}}`;
    // console.log("ItemListSchema 1", itemSchema);
    // itemSchema = itemSchema.replace(/\\/g, "");

    return itemArray;
  };

  console.log("CHUNVA DAATA ", homePageVideosData);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "fb:pages",
        content: "1453842511589254",
        className: "jsx-2940179559"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: "".concat(router.pathname === "/" ? "Hindi News, Hindi Samachar, Breaking News in Hindi, Today Headlines, Latest News in Hindi, हिंदी समाचार, हिंदी न्यूज़, ताजा ख़बरें" : router.pathname === "/text" ? "Hindi news Article, news story in hindi, breaking news article in hindi, latest news article in hindi, latest hindi news Stories, today news story in hindi, hindi news story today, हिंदी न्यूज़ पढ़िए, हिन्दी समाचार पढ़िए, पढ़िए हिंदी में समाचार" : router.pathname === "/video" ? "Hindi news Video, Video story in hindi, breaking news Video in hindi, latest news Video in hindi, latest hindi news Video, watch today news story in hindi, hindi news today, हिंदी न्यूज़ देखिये, हिन्दी समाचार देखिये, देखिये हिंदी में समाचार, Trending Video, Viral Video today" : "Hindi news Audio, audio story in hindi, breaking news podcast in hindi, latest news podcast in hindi, latest hindi news audio stories, Listen today news story in hindi, hindi news today, हिंदी न्यूज़ सुनिए, हिन्दी समाचार सुनिए, सुनिए हिंदी में समाचार, Trending audio stories, Viral podcast today"),
        className: "jsx-2940179559"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preconnect",
        crossOrigin: "true",
        href: "https://static.chartbeat.com",
        className: "jsx-2940179559"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        dangerouslySetInnerHTML: {
          __html: "\n            (function () {\n              var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});\n              _sf_async_config.uid = 60355;\n              _sf_async_config.domain = 'thelallantop.com';\n              _sf_async_config.useCanonical = true;\n              _sf_async_config.useCanonicalDomain = true;\n              _sf_async_config.sections = 'about'; \n              _sf_async_config.authors = '';\n              function loadChartbeat() {\n                  var e = document.createElement('script');\n                  var n = document.getElementsByTagName('script')[0];\n                  e.type = 'text/javascript';\n                  e.async = true;\n                  e.src = '//static.chartbeat.com/js/chartbeat.js';\n                  n.parentNode.insertBefore(e, n);\n              }\n              loadChartbeat();\n          })();\n       "
        },
        strategy: "afterInteractive",
        id: "chartbeat",
        type: "text/javascript",
        className: "jsx-2940179559"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preconnect",
        crossOrigin: "true",
        href: "https://www.gstatic.com",
        className: "jsx-2940179559"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preconnect",
        crossOrigin: "true",
        href: "https://f.vimeocdn.com",
        className: "jsx-2940179559"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: router.pathname === "/" ? "Hindi News, ताज़ा हिंदी समाचार | Breaking News Headlines Today in Hindi | Latest News Today Hindi | हिंदी न्यूज़ | The Lallantop" : router.pathname === "/text" ? "Hindi News Article, हिंदी न्यूज़ पढ़िए , Today Breaking News Article In Hindi, Today News Headlines" : router.pathname === "/video" ? "Hindi News Video, Trending Video हिंदी न्यूज़ , Today Breaking News Video, Today News Video" : "Hindi News Podcast, Trending podcast हिंदी न्यूज़ , Today Breaking News सुनिए, Today News Podcast",
      canonical: "https://www.thelallantop.com" + (router.asPath.includes("/text") ? "/text" : router.asPath.includes("/video") ? "/video" : ""),
      description: router.pathname === "/" ? "Hindi News (हिंदी न्यूज़) - Read here देश, विदेश, खेल, राजनीति, क्राइम, ऑटोमोबाइल, टेक्नोलॉजी, शिक्षा, लाइफस्टाइल, क्रिकेट से सम्बंधित आज की मुख्य खबरें, ताज़ा हिंदी समाचार (Latest Hindi News), ब्रेकिंग न्यूज़ (Breaking News) और लेटेस्ट न्यूज़ (Latest News in Hindi) हिंदी में on The Lallantop." : router.pathname === "/text" ? "Hindi News Article (हिंदी न्यूज़) - पढ़िए देश, विदेश, खेल, राजनीति, क्राइम, ऑटोमोबाइल, टेक्नोलॉजी, शिक्षा, लाइफस्टाइल, क्रिकेट और ज्योतिष से सम्बंधित सभी समाचार हिंदी में (News Stories In Hindi) Lallantop पर.  Read Breaking News Headlines in Hindi on lallantop Website." : router.pathname === "/video" ? "Hindi News Viral Video (हिंदी न्यूज़) - Watch देश, विदेश, खेल, राजनीति, क्राइम, ऑटोमोबाइल, टेक्नोलॉजी, शिक्षा, लाइफस्टाइल, क्रिकेट और ज्योतिष से सम्बंधित सभी समाचार हिंदी में (Video Stories In Hindi) Lallantop पर.  Watch Trending News Video in Hindi on lallantop Website." : " Hindi News Viral Podcast (हिंदी न्यूज़) - listen देश, विदेश, खेल, राजनीति, क्राइम, ऑटोमोबाइल, टेक्नोलॉजी, शिक्षा, लाइफस्टाइल, क्रिकेट और ज्योतिष से सम्बंधित सभी समाचार हिंदी में (Podcast Stories In Hindi) Lallantop पर.  Watch Trending News PODCAST in Hindi on lallantop Website."
    }), firstScroll && /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "taboola" //strategy="afterInteractive"
      ,
      type: "text/javascript",
      dangerouslySetInnerHTML: {
        __html: "\n              window._taboola = window._taboola || [];\n              _taboola.push({homepage:'auto'});\n              !function (e, f, u, i) {\n              if (!document.getElementById(i)){\n              e.async = 1;\n              e.src = u;\n              e.id = i;\n              f.parentNode.insertBefore(e, f);\n              }\n              }(document.createElement('script'),\n              document.getElementsByTagName('script')[0],\n              '//cdn.taboola.com/libtrc/indiatoday-thelallantop/loader.js',\n              'tb_loader_script');\n              if(window.performance && typeof window.performance.mark == 'function')\n              {window.performance.mark('tbl_ic');}\n              "
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: {
        overflow: "hidden"
      },
      className: "jsx-2940179559" + " " + "container-row py-2 text-center deaktop-header-ad",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        style: {
          fontSize: "11px",
          color: "#b7b7b7",
          marginBottom: "0px"
        },
        className: "jsx-2940179559",
        children: "Advertisement"
      }), size.width > 600 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "div-gpt-ad-1701945163318-0",
        style: {
          minHeight: "100px",
          alignContent: "center",
          textAlign: "-webkit-center"
        },
        className: "jsx-2940179559",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          type: "text/javascript",
          defer: true,
          dangerouslySetInnerHTML: {
            __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})"
          },
          className: "jsx-2940179559"
        })
      })]
    }), cricketData && scoreData && pointsData && masterConfig['IPL']['MainBanners'] && /*#__PURE__*/(0,jsx_runtime.jsx)(WidgetHomeIpl, {
      newsData: cricketData,
      scoreData: scoreData,
      pointsData: pointsData,
      table: pointsData.standings.stage1.groups[0],
      size: size
    }), (masterObj === null || masterObj === void 0 ? void 0 : masterObj.Homepage_Strip) && (size.width < 768 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "jsx-2940179559",
        children: [console.log('abccccccccc'), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            paddingTop: "1rem",
            gap: "8px",
            // cursor: "pointer",
            paddingBottom: "1rem",
            backgroundColor: "white",
            marginTop: "10px"
          },
          className: "jsx-2940179559",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/assembly-chunav.png",
            width: "240px",
            height: "auto",
            style: {
              alignSelf: "center"
            },
            className: "jsx-2940179559"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          "class": "divCategoriesSchedule2 snipcss-eqdpv",
          style: {
            margin: "-1px 0px",
            backgroundColor: "white",
            paddingLeft: "15px",
            paddingBottom: "1rem",
            justifyContent: router.asPath.includes("jharkhand-") || router.asPath.includes("maharashtra-") ? "center" : "space-around"
          },
          className: "jsx-2940179559",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("br", {
            className: "jsx-2940179559"
          }), STATIC_BREADCRUMP.map(function (item, index) {
            return masterObj[item.keyToShow] != false ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: item.url,
              className: "jsx-2940179559",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "jsx-2940179559",
                children: item.displayText
              })
            }, index) : null;
          })]
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: (size === null || size === void 0 ? void 0 : size.width) >= 768 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          width: "max-content",
          margin: "auto",
          gap: "68px",
          height: "80px",
          marginTop: "15px",
          marginBottom: "15px",
          borderRadius: "12px",
          padding: "0px 30px"
        },
        className: "jsx-2940179559",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            // paddingTop: "1rem",
            gap: "8px",
            // cursor: "pointer",
            backgroundColor: "white",
            paddingLeft: "0px"
          },
          className: "jsx-2940179559",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/assembly-chunav.png",
            width: "408.56px",
            height: "58.21px",
            style: {
              alignSelf: "center"
            },
            className: "jsx-2940179559"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
          className: "jsx-2940179559"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "class": "divCategoriesSchedule2 snipcss-eqdpv",
          style: {
            margin: "0px 0px",
            // backgroundColor: "rgb(217, 54, 139)",
            paddingLeft: "15px",
            alignContent: "center"
          },
          className: "jsx-2940179559",
          children: STATIC_BREADCRUMP.map(function (item, index) {
            return masterObj[item.keyToShow] != false ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: item.url,
              className: "jsx-2940179559",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "jsx-2940179559",
                children: item.displayText
              })
            }, index) : null;
          })
        })]
      })
    })), size.width < 768 && (masterObj === null || masterObj === void 0 ? void 0 : masterObj.MoveAdsUp) == true && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      align: "center",
      className: "jsx-2940179559" + " " + "container-row py-2 mobile-header-ad",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        style: {
          fontSize: "11px",
          color: "#b7b7b7",
          marginBottom: "0px"
        },
        className: "jsx-2940179559",
        children: "Advertisement"
      }), size.width < 768 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "div-gpt-ad-1701946028239-0",
        style: {
          minHeight: "260px",
          alignContent: "center",
          textAlign: "-webkit-center"
        },
        className: "jsx-2940179559",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          type: "text/javascript",
          defer: true,
          dangerouslySetInnerHTML: {
            __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})"
          },
          className: "jsx-2940179559"
        })
      })]
    }), masterObj.Exittally && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "jsx-2940179559" + " " + "result-page",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          className: "jsx-2940179559",
          children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u090F\u0917\u094D\u095B\u093F\u091F \u092A\u094B\u0932"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "jsx-2940179559",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
            scrolling: "no",
            src: "".concat(masterObj.Exittally_URL),
            width: "100%",
            height: masterObj.Exitpolltally_height_mobile,
            className: "jsx-2940179559"
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          backgroundColor: "white"
        },
        className: "jsx-2940179559",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "jsx-2940179559" + " " + "result-page main-container-featured1",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            style: size.width >= 800 && size.width <= 1000 ? {
              fontSize: "27px",
              color: "#D9368B",
              fontWeight: "800",
              marginTop: "45px"
            } : {
              fontSize: "27px",
              color: "#D9368B",
              fontWeight: "800"
            },
            className: "jsx-2940179559",
            children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u090F\u0917\u094D\u095B\u093F\u091F \u092A\u094B\u0932"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "jsx-2940179559",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
              scrolling: "no",
              src: "".concat(masterObj.Exittally_URL),
              width: "100%",
              height: masterObj.Exitpolltally_height_web,
              className: "jsx-2940179559"
            })
          })]
        })
      })
    }), masterObj.Resulttally && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "jsx-2940179559" + " " + "result-page-big",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          className: "jsx-2940179559",
          children: "\u0926\u093F\u0932\u094D\u0932\u0940 \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "jsx-2940179559",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
            scrolling: "no",
            src: masterObj.Resulttally_URL,
            width: "100%",
            height: masterObj.Resulttally_height_mobile,
            className: "jsx-2940179559"
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          backgroundColor: "white"
        },
        className: "jsx-2940179559",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "jsx-2940179559" + " " + "result-page-big main-container-featured1",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            style: {
              fontSize: "27px",
              color: "#D9368B",
              fontWeight: "800"
            },
            className: "jsx-2940179559",
            children: "\u0926\u093F\u0932\u094D\u0932\u0940 \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "jsx-2940179559",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
              scrolling: "no",
              src: masterObj.Resulttally_URL,
              width: "100%",
              height: size.width != 820 && size.width <= 1000 ? masterObj.Resulttally_height_tab : masterObj.Resulttally_height_web,
              className: "jsx-2940179559"
            })
          })]
        })
      })
    }), masterObj.BypollResulttally && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "jsx-2940179559" + " " + "result-page-big",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          className: "jsx-2940179559",
          children: "\u0909\u092A\u091A\u0941\u0928\u093E\u0935 \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "jsx-2940179559",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
            scrolling: "no",
            src: masterObj.BypollResulttally_URL,
            width: "100%",
            height: masterObj.Bypoll_Resulttally_height_mobile,
            className: "jsx-2940179559"
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "jsx-2940179559" + " " + "result-page-big",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          className: "jsx-2940179559",
          children: "\u0909\u092A\u091A\u0941\u0928\u093E\u0935 \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "jsx-2940179559",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
            scrolling: "no",
            src: masterObj.BypollResulttally_URL,
            width: "100%",
            height: masterObj.Bypoll_Resulttally_height_web,
            className: "jsx-2940179559"
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(mainContainer/* default */.Z, {
      masterObj: masterObj,
      featuredPosts: featuredPosts,
      bannerData: bannerData,
      liveShowData: liveShowData // cricketResponse={cricketResponse}
      ,
      quizPage: quizHomeData,
      firstScroll: firstScroll,
      newsData: cricketData
    }), loadScrollableComponents && /*#__PURE__*/(0,jsx_runtime.jsx)(LatestVideos, {
      homePageVideosData: homePageVideosData,
      router: router,
      language: language
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "jsx-2940179559" + " " + "container whats",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        href: "https://whatsapp.com/channel/0029Va9lDkJDp2QAHxZogJ2r",
        target: "_blank",
        rel: "noreferrer",
        className: "jsx-2940179559" + " " + "whatsappChannel",
        children: ["\u0932\u0932\u094D\u0932\u0928\u091F\u0949\u092A \u0915\u093E", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "jsx-2940179559" + " " + "greenW",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "76.001",
            height: "76",
            viewBox: "0 0 76.001 76",
            className: "jsx-2940179559",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
              "data-name": "Group 50357",
              transform: "translate(-203.999 -353.381)",
              className: "jsx-2940179559",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                id: "Path_17532",
                "data-name": "Path 17532",
                d: "M38.014,76h0a38.26,38.26,0,0,1-18.066-4.551L3.4,75.881A2.68,2.68,0,0,1,.108,72.594L4.546,56.04A38.258,38.258,0,0,1,.323,32.988,38.022,38.022,0,0,1,23.583,2.84,38,38,0,1,1,43.011,75.671,38.277,38.277,0,0,1,38.014,76ZM24.655,19.749a2.189,2.189,0,0,0-1.556.646,24.919,24.919,0,0,0,0,35.212,2.2,2.2,0,0,0,3.111,0,2.191,2.191,0,0,0,0-3.11,20.518,20.518,0,0,1,0-28.98,2.212,2.212,0,0,0,0-3.123A2.189,2.189,0,0,0,24.655,19.749Zm26.689,0a2.2,2.2,0,0,0-1.556,3.757,20.492,20.492,0,0,1,0,28.98,2.2,2.2,0,0,0,0,3.11,2.209,2.209,0,0,0,3.111,0,24.9,24.9,0,0,0,0-35.2A2.189,2.189,0,0,0,51.345,19.749ZM38.5,32a6,6,0,1,0,6,6A6.008,6.008,0,0,0,38.5,32Z",
                transform: "translate(204 353.381)",
                fill: "#58be55",
                className: "jsx-2940179559"
              }), " "]
            }), " "]
          })
        }), "\u091A\u0948\u0928\u0932", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          "class": "waJoin",
          className: "jsx-2940179559",
          children: "JOIN"
        }), "\u0915\u0930\u0947\u0902"]
      })
    }), !isSubscribed && /*#__PURE__*/(0,jsx_runtime.jsx)(NewsLetter_FooterNewsLetter, {
      size: size
    }), loadScrollableComponents && (router.asPath.split("?")[0] === "/" || router.asPath.split("?")[0] === "/video") && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [size.width < 600 && router.asPath.split("?")[0] === "/" && /*#__PURE__*/(0,jsx_runtime.jsx)(googleAdContainer/* default */.Z, {
        divId: "div-gpt-ad-1701946028239-1"
      }), !router.pathname.includes("/text") && !router.pathname.includes("/video") && /*#__PURE__*/(0,jsx_runtime.jsx)(VisualStories, {
        responseVs: responseVs === null || responseVs === void 0 ? void 0 : (_responseVs$data = responseVs.data) === null || _responseVs$data === void 0 ? void 0 : _responseVs$data.all,
        liveBlogWidgetData: liveBlogWidgetData
      }), size.width < 600 && router.asPath.split("?")[0] === "/video" && /*#__PURE__*/(0,jsx_runtime.jsx)(googleAdContainer/* default */.Z, {
        divId: "div-gpt-ad-1701946028239-0"
      })]
    }), size.width > 600 && !router.pathname.includes("/text") && !router.pathname.includes("/video") && /*#__PURE__*/(0,jsx_runtime.jsx)(googleAdContainer/* default */.Z, {
      divId: "div-gpt-ad-1701945220410-1"
    }), size.width <= 499 && liveBlogWidgetData && (liveBlogWidgetData === null || liveBlogWidgetData === void 0 ? void 0 : liveBlogWidgetData.length) > 0 && !router.pathname.includes("/text") && !router.pathname.includes("/video") && /*#__PURE__*/(0,jsx_runtime.jsx)(BlogWidget, {
      liveBlogWidgetData: liveBlogWidgetData
    }), size.width <= 499 && !router.pathname.includes("/video") && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      align: "center",
      className: "jsx-2940179559" + " " + "container-row py-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        style: {
          fontSize: "11px",
          color: "#b7b7b7",
          marginBottom: "0px"
        },
        className: "jsx-2940179559",
        children: "Advertisement"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: size.width > 600 ? router.asPath.split("?")[0] === "/" ? "div-gpt-ad-1701945220410-2" : router.asPath.split("?")[0] === "/text" ? "div-gpt-ad-1701945220410-1" : "div-gpt-ad-1701945220410-2" : router.pathname === "/" ? "div-gpt-ad-1701946028239-2" : router.asPath.split("?")[0] === "/text" ? "div-gpt-ad-1701946028239-0" : "div-gpt-ad-1701946028239-1",
        style: {
          minWidth: "300px",
          minHeight: size.width > 600 ? "100px" : "260px",
          display: "block !important",
          alignContent: "center",
          textAlign: "-webkit-center"
        },
        className: "jsx-2940179559",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          type: "text/javascript",
          dangerouslySetInnerHTML: {
            __html: size.width > 600 ? router.asPath.split("?")[0] === "/" ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-2')})" : router.asPath.split("?")[0] === "/text" ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})" : router.pathname === "/" ? "\n              {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-2')})\n              " : router.asPath.split("?")[0] === "/text" ? "\n              {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})\n              " : "\n              {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})\n              "
          },
          className: "jsx-2940179559"
        })
      })]
    }), loadScrollableComponents && /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryPosts, {
      shortsData: shortsData,
      NewsPageData: NewsPageData,
      topShowsWidgetData: topShowsWidgetData,
      topPodcastData: topPodcastData,
      authorWidgetData: authorWidgetData
    }), size.width < 600 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
        align: "center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          align: "center",
          className: "jsx-2940179559" + " " + "container-row py-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center",
              marginBottom: "0px"
            },
            className: "jsx-2940179559",
            children: "Advertisement"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            id: "div-gpt-ad-1701946028239-3",
            style: {
              minWidth: "300px",
              minHeight: "260px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            className: "jsx-2940179559" + " " + "ads-auto-resize",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-3')})"
              },
              className: "jsx-2940179559"
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TaboolaAdContainer, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      id: "website-schema",
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(breadcrumb)
      },
      className: "jsx-2940179559"
    }), "(", /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      id: "website-schema-item",
      type: "application/ld+json" // strategy="afterInteractive"
      ,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          itemListElement: ItemListSchema()
        })
      },
      className: "jsx-2940179559"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      id: "my-script-detail",
      type: "application/ld+json",
      strategy: "afterInteractive",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "http://schema.org/",
          "@type": "WebPage",
          name: "".concat(router.pathname === "/" ? "Hindi News, ताज़ा हिंदी समाचार | Breaking News Headlines Today in Hindi | Latest News Today Hindi | हिंदी न्यूज़ | The Lallantop" : router.pathname === "/text" ? "Hindi News Article, हिंदी न्यूज़ पढ़िए , Today Breaking News Article In Hindi, Today News Headlines" : router.pathname === "/video" ? "Hindi News Video, Trending Video हिंदी न्यूज़ , Today Breaking News Video, Today News Video" : "Hindi News Podcast, Trending podcast हिंदी न्यूज़ , Today Breaking News सुनिए, Today News Podcast"),
          description: "".concat(router.pathname === "/" ? "Hindi News (हिंदी न्यूज़) - Read here देश, विदेश, खेल, राजनीति, क्राइम, ऑटोमोबाइल, टेक्नोलॉजी, शिक्षा, लाइफस्टाइल, क्रिकेट से सम्बंधित आज की मुख्य खबरें, ताज़ा हिंदी समाचार (Latest Hindi News), ब्रेकिंग न्यूज़ (Breaking News) और लेटेस्ट न्यूज़ (Latest News in Hindi) हिंदी में on The Lallantop." : router.pathname === "/text" ? "Hindi News Article (हिंदी न्यूज़) - पढ़िए देश, विदेश, खेल, राजनीति, क्राइम, ऑटोमोबाइल, टेक्नोलॉजी, शिक्षा, लाइफस्टाइल, क्रिकेट और ज्योतिष से सम्बंधित सभी समाचार हिंदी में (News Stories In Hindi) Lallantop पर.  Read Breaking News Headlines in Hindi on lallantop Website." : router.pathname === "/video" ? "Hindi News Viral Video (हिंदी न्यूज़) - Watch देश, विदेश, खेल, राजनीति, क्राइम, ऑटोमोबाइल, टेक्नोलॉजी, शिक्षा, लाइफस्टाइल, क्रिकेट और ज्योतिष से सम्बंधित सभी समाचार हिंदी में (Video Stories In Hindi) Lallantop पर.  Watch Trending News Video in Hindi on lallantop Website." : " Hindi News Viral Podcast (हिंदी न्यूज़) - listen देश, विदेश, खेल, राजनीति, क्राइम, ऑटोमोबाइल, टेक्नोलॉजी, शिक्षा, लाइफस्टाइल, क्रिकेट और ज्योतिष से सम्बंधित सभी समाचार हिंदी में (Podcast Stories In Hindi) Lallantop पर.  Watch Trending News PODCAST in Hindi on lallantop Website."),
          keywords: "".concat(router.pathname === "/" ? "Hindi News, Hindi Samachar, Breaking News in Hindi, Today Headlines, Latest News in Hindi, हिंदी समाचार, हिंदी न्यूज़, ताजा ख़बरें" : router.pathname === "/text" ? "Hindi news Article, news story in hindi, breaking news article in hindi, latest news article in hindi, latest hindi news Stories, today news story in hindi, hindi news story today, हिंदी न्यूज़ पढ़िए, हिन्दी समाचार पढ़िए, पढ़िए हिंदी में समाचार" : router.pathname === "/video" ? "Hindi news Video, Video story in hindi, breaking news Video in hindi, latest news Video in hindi, latest hindi news Video, watch today news story in hindi, hindi news today, हिंदी न्यूज़ देखिये, हिन्दी समाचार देखिये, देखिये हिंदी में समाचार, Trending Video, Viral Video today" : "Hindi news Audio, audio story in hindi, breaking news podcast in hindi, latest news podcast in hindi, latest hindi news audio stories, Listen today news story in hindi, hindi news today, हिंदी न्यूज़ सुनिए, हिन्दी समाचार सुनिए, सुनिए हिंदी में समाचार, Trending audio stories, Viral podcast today"),
          url: "https://www.thelallantop.com".concat(router.pathname),
          publisher: {
            "@type": "Organization",
            name: "The Lallantop",
            url: "https://www.thelallantop.com/",
            logo: {
              "@type": "ImageObject",
              url: "https://www.thelallantop.com/assets/images/lallatop-logo-m.svg",
              width: 600,
              height: 60
            }
          }
        })
      },
      className: "jsx-2940179559"
    }), ")", show && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "jsx-2940179559",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        onClick: handleClose,
        style: {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1040
        },
        className: "jsx-2940179559"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          top: '50%',
          left: '50%',
          transform: 'translate(100%, -50%)',
          // Starts off-screen right
          backgroundColor: '#FBF8F1',
          borderRadius: '10px',
          zIndex: 1050,
          width: '90%',
          maxWidth: '500px',
          padding: '1.5rem'
        },
        className: "jsx-2940179559" + " " + "modal-slide-in position-fixed",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            width: '170px',
            height: '179px'
          },
          className: "jsx-2940179559" + " " + "mx-auto mb-4 ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "./assets/images/news_letter.png",
            alt: "Newsletter",
            className: "jsx-2940179559" + " " + "w-100 h-100"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "jsx-2940179559",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            style: {
              fontFamily: 'Mukta,system-ui, -apple-system, BlinkMacSystemFont',
              fontWeight: 900,
              fontSize: '25px'
            },
            className: "jsx-2940179559" + " " + "m-0 p-0 text-center ",
            children: "Subscribe"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            style: {
              fontFamily: 'Mukta,system-ui, -apple-system, BlinkMacSystemFont',
              fontWeight: 900,
              fontSize: '25px'
            },
            className: "jsx-2940179559" + " " + "m-0 p-0 text-center",
            children: "to Our Newsletter"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: containerStyle,
          className: "jsx-2940179559" + " " + "shadow-sm mx-auto my-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            value: email,
            onChange: function onChange(event) {
              return setEmail(event.target.value);
            },
            type: "email",
            placeholder: "Enter Your Email",
            style: inputStyle,
            onKeyDown: function onKeyDown(e) {
              if (e.key === "Enter") {
                handleSubscribeClick();
              }
            },
            className: "jsx-2940179559" + " " + "form-control-plaintext"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            onClick: handleSubscribeClick,
            style: buttonStyle,
            className: "jsx-2940179559" + " " + "ms-2",
            children: subscribeLoading ? '...' : 'SUBSCRIBE'
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          dangerouslySetInnerHTML: {
            __html: bottomText
          },
          style: {
            fontWeight: isError ? 600 : 200,
            fontSize: isError ? '13px' : "9px",
            color: isError ? "red" : "#333"
          },
          className: "jsx-2940179559" + " " + "m-0 p-0 text-center"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: "2940179559",
      children: ["@-webkit-keyframes slideInRight-jsx-2940179559{from{-webkit-transform:translateX(100%) translate(-50%,-50%);-ms-transform:translateX(100%) translate(-50%,-50%);transform:translateX(100%) translate(-50%,-50%);opacity:0;}to{-webkit-transform:translateX(0%) translate(-50%,-50%);-ms-transform:translateX(0%) translate(-50%,-50%);transform:translateX(0%) translate(-50%,-50%);opacity:1;}}", "@keyframes slideInRight-jsx-2940179559{from{-webkit-transform:translateX(100%) translate(-50%,-50%);-ms-transform:translateX(100%) translate(-50%,-50%);transform:translateX(100%) translate(-50%,-50%);opacity:0;}to{-webkit-transform:translateX(0%) translate(-50%,-50%);-ms-transform:translateX(0%) translate(-50%,-50%);transform:translateX(0%) translate(-50%,-50%);opacity:1;}}", ".modal-slide-in.jsx-2940179559{-webkit-animation:slideInRight-jsx-2940179559 0.6s ease-out forwards;animation:slideInRight-jsx-2940179559 0.6s ease-out forwards;}"]
    })]
  });
};

/* harmony default export */ var homePage = (HomePage);

/***/ }),

/***/ 31445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ unSubscribe; },
/* harmony export */   "HH": function() { return /* binding */ requestSubscription; },
/* harmony export */   "LF": function() { return /* binding */ showPopupOrNot; },
/* harmony export */   "h9": function() { return /* binding */ confirmSubscription; }
/* harmony export */ });
/* unused harmony export APIS */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var api_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9041);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);




var APIS = {
  requestSubscribe: "/newsletter/requestSubscription",
  confirmSubscribe: "/newsletter/confirmSubscription",
  checkSubscriptionStatus: "/newsletter/subscriptionStatus",
  unsubscribe: "/newsletter/unsubscribe"
};
var requestSubscription = function requestSubscription(email) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(resolve, reject) {
      var url, res, _err$response, _err$response2, _err$response2$data, _err$response3, _err$response3$data;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              url = api_constants__WEBPACK_IMPORTED_MODULE_3__/* .baseUrl */ .FH + APIS['requestSubscribe'];
              _context.next = 4;
              return axios__WEBPACK_IMPORTED_MODULE_1___default().post(url, {
                email: email
              });

            case 4:
              res = _context.sent;
              resolve({
                success: true,
                data: res === null || res === void 0 ? void 0 : res.data
              });
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error("Subscription error:", _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.response);
              reject({
                success: false,
                data: _context.t0 !== null && _context.t0 !== void 0 && _context.t0.response && _context.t0 !== null && _context.t0 !== void 0 && _context.t0.response && _context.t0 !== null && _context.t0 !== void 0 && (_err$response = _context.t0.response) !== null && _err$response !== void 0 && _err$response.data && _context.t0 !== null && _context.t0 !== void 0 && (_err$response2 = _context.t0.response) !== null && _err$response2 !== void 0 && (_err$response2$data = _err$response2.data) !== null && _err$response2$data !== void 0 && _err$response2$data.message ? _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response3 = _context.t0.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : _err$response3$data.message : _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};
var confirmSubscription = function confirmSubscription(token) {
  return new Promise( /*#__PURE__*/function () {
    var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(resolve, reject) {
      var _res$data, url, res;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              url = api_constants__WEBPACK_IMPORTED_MODULE_3__/* .baseUrl */ .FH + APIS['confirmSubscribe'];
              _context2.next = 4;
              return axios__WEBPACK_IMPORTED_MODULE_1___default().post(url, {
                token: token
              });

            case 4:
              res = _context2.sent;

              if (res && res !== null && res !== void 0 && res.data && res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.status) {
                resolve({
                  success: true,
                  data: res === null || res === void 0 ? void 0 : res.data
                });
              } else {
                reject({
                  success: false,
                  data: "Something went wrong"
                });
              }

              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              console.error("Confirm Subscription error:", _context2.t0);
              reject({
                success: false,
                data: _context2.t0 !== null && _context2.t0 !== void 0 && _context2.t0.message ? _context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message : "Something went wrong"
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
};
var unSubscribe = function unSubscribe(email) {
  var reasonString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return new Promise( /*#__PURE__*/function () {
    var _ref3 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(resolve, reject) {
      var _res$data2, url, res;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              url = api_constants__WEBPACK_IMPORTED_MODULE_3__/* .baseUrl */ .FH + APIS['unsubscribe'];
              _context3.next = 4;
              return axios__WEBPACK_IMPORTED_MODULE_1___default().post(url, {
                email: email,
                unsubscribeReason: reasonString
              });

            case 4:
              res = _context3.sent;

              if (res && res !== null && res !== void 0 && res.data && res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.status) {
                resolve({
                  success: true,
                  data: res === null || res === void 0 ? void 0 : res.data
                });
              } else {
                reject({
                  success: false,
                  data: "Something went wrong"
                });
              }

              _context3.next = 12;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              console.error("Unsubscribe error:", _context3.t0);
              reject({
                success: false,
                data: _context3.t0 !== null && _context3.t0 !== void 0 && _context3.t0.message ? _context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message : "Something went wrong"
              });

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 8]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }());
};
var showPopupOrNot = function showPopupOrNot() {
  //show popup only when user or guest has not subscribed yet
  var subscribed = localStorage.getItem('subscribed');

  if (subscribed) {
    //user have subscribed so will not show the popup
    return false;
  } else {
    var lastShowedSubscribe = localStorage.getItem('lastShowedSubscribe');

    if (lastShowedSubscribe) {
      var diff = getDaysDifference(lastShowedSubscribe, Date.now());
      console.log(diff, ' difference in seconds');

      if (diff > 3) {
        //last popup is being showed 3 days before
        return true;
      } else {
        //last popup is being within last 3 days
        return false;
      }
    } //popop is being showed for the first time
    else {
      return true;
    }
  }
};

function getDaysDifference(startTimestamp, endTimestamp) {
  var msInDay = 1000 * 60 * 60 * 24;
  var diffMs = endTimestamp - startTimestamp;
  return Math.floor(diffMs / msInDay);
}

function getSecondsDifference(startTimestampMs, endTimestampMs) {
  return Math.floor((endTimestampMs - startTimestampMs) / 1000);
}

/***/ }),

/***/ 98033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CO": function() { return /* binding */ setVideoIsShow; },
/* harmony export */   "ZF": function() { return /* binding */ getSeriesById; },
/* harmony export */   "bx": function() { return /* binding */ followedSeriesData; },
/* harmony export */   "s": function() { return /* binding */ setScoreData; }
/* harmony export */ });
/* unused harmony export getSeries */
/* harmony import */ var redux_actionTypes_series_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(794);
 // SERIES ACTIONS

var getSeries = function getSeries(payload) {
  return {
    type: SERIES_GET_INIT,
    payload: payload
  };
};
var getSeriesById = function getSeriesById(payload) {
  return {
    type: redux_actionTypes_series_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SERIES_GET_BY_ID_INIT */ .oH,
    payload: payload
  };
}; // SERIES FOLLOWED ACTIONS

var followedSeriesData = function followedSeriesData(payload) {
  return {
    type: redux_actionTypes_series_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SERIES_FOLLOWED_INIT */ .hD,
    payload: payload
  };
};
var setScoreData = function setScoreData(payload) {
  return {
    type: redux_actionTypes_series_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SET_SCOREDATA */ .VI,
    payload: payload
  };
};
var setVideoIsShow = function setVideoIsShow(payload) {
  return {
    type: redux_actionTypes_series_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SET_VIDEO_IS_SHOW */ .CG,
    payload: payload
  };
};

/***/ })

}]);